import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFreebsdComponent } from './simple-icons-freebsd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFreebsdComponent ],
    exports:      [ SimpleIconsFreebsdComponent ],
    bootstrap:    []
})
export class SimpleIconsFreebsdModule {}
